import Vue from 'vue';
import Router from 'vue-router';


import CheckEmail from '@/pages/contract_form/CheckEmail';
import EkycHoujinProxyMsgTop from '@/pages/contract_form/EkycHoujinProxyTop';
import UpdateForm from '@/pages/contract_form/UpdateForm';
import ReflectSalesForce from '@/pages/sales_force/ReflectSalesForce';
import ReflectSalesForcePre from '@/pages/sales_force/ReflectSalesForcePre';
import IdentificationForm from '@/pages/identification_form/IdentificationForm';
import IdentificationCompanyOnlyForm from '@/pages/identification_form/IdentificationCompanyOnlyForm';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'CheckEmail',
            component: CheckEmail
        },
        {
            path: '/update/:documentId',
            name: 'UpdateForm',
            component: UpdateForm
        },
        {
            path: '/sales_force/:documentId',
            name: 'ReflectSalesForce',
            component: ReflectSalesForce
        },
        {
            path: '/sales_force',
            name: 'ReflectSalesForceTop',
            component: ReflectSalesForce
        },
        {
            path: '/sales_force_pre',
            name: 'ReflectSalesForcePreTop',
            component: ReflectSalesForcePre
        },
        {
            path: '/sales_force_pre/:documentId',
            name: 'ReflectSalesForcePre',
            component: ReflectSalesForcePre
        },
        {
            path: '/ekyc/:applicationId',
            name: 'IdentificationForm',
            component: IdentificationForm
        },
        {
            path: '/ekyc_proxy/:applicationId',
            name: 'IdentificationCompanyOnlyForm',
            component: IdentificationCompanyOnlyForm
        },
        {
            path: '/ekyc_proxy_error',
            name: 'EkycHoujinProxyConfirmMsgTop',
            component: EkycHoujinProxyMsgTop
        }

    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js